import { useState, useEffect } from 'react';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const StarRating = ({ rating }) => {
    return (
      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <svg
            key={i}
            className={`w-5 h-5 ${i < rating ? 'text-yellow-400' : 'text-gray-300'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
          </svg>
        ))}
      </div>
    );
  };

  const testimonials = [
    { 
      quote: "RPS Digital transformed our online presence completely. Their attention to detail and professionalism is unmatched. Our website traffic increased by 300% in just 3 months!", 
      author: "Sarah Johnson", 
      role: "CEO, TechStart Inc.",
      rating: 5
    },
    { 
      quote: "Working with RPS was a game-changer. They delivered beyond our expectations and provided excellent support throughout the entire process. Highly recommended!", 
      author: "Michael Chen", 
      role: "Founder, Global Solutions",
      rating: 5
    },
    { 
      quote: "The team at RPS Digital is incredibly talented and responsive. They understood our vision and brought it to life perfectly. Our new website has significantly improved our brand image.", 
      author: "Emily Rodriguez", 
      role: "Marketing Director, InnovateCo",
      rating: 5
    },
    { 
      quote: "Outstanding service from start to finish! RPS Digital created a beautiful, fast, and user-friendly website that perfectly represents our business. The results speak for themselves.", 
      author: "David Kim", 
      role: "Business Owner, Prime Services",
      rating: 5
    },
    { 
      quote: "RPS Digital exceeded all our expectations. Their custom software solution streamlined our operations and saved us countless hours. The team is professional, creative, and reliable.", 
      author: "Lisa Anderson", 
      role: "Operations Manager, Enterprise Plus",
      rating: 5
    },
    { 
      quote: "We've worked with many agencies, but RPS Digital stands out. Their mobile app development expertise is exceptional, and the final product exceeded our wildest expectations. Truly impressive!", 
      author: "James Wilson", 
      role: "CTO, Digital Ventures",
      rating: 5
    },
  ];

  // Auto-slide functionality
  useEffect(() => {
    const maxIndex = testimonials.length - 3;
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex >= maxIndex ? 0 : prevIndex + 1));
        setIsTransitioning(false);
      }, 300);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const visibleTestimonials = testimonials.slice(currentIndex, currentIndex + 3);

  return (
    <section className="w-full bg-gradient-to-b from-white to-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 rounded-full bg-purple-500/10 border border-purple-500/30">
            <span className="text-purple-600 text-sm font-semibold">Testimonials</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Our <span className="bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent">Clients Say</span>
          </h2>
          <p className="text-xl text-gray-600">Real feedback from businesses we've helped transform</p>
        </div>
        <div className="relative overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {visibleTestimonials.map((testimonial, index) => (
              <div 
                key={`${currentIndex}-${index}`}
                className={`bg-white rounded-2xl p-8 shadow-lg border border-gray-200 hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 ${
                  isTransitioning ? 'opacity-0' : 'opacity-100'
                }`}
              >
                <StarRating rating={testimonial.rating} />
                <p className="text-gray-700 mb-6 text-base leading-relaxed">
                  "{testimonial.quote}"
                </p>
                <div className="pt-4 border-t border-gray-200">
                  <p className="text-gray-900 font-bold text-lg mb-1">{testimonial.author}</p>
                  <p className="text-gray-500 text-sm">{testimonial.role}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Dots indicator */}
        <div className="flex justify-center gap-2 mt-8">
          {Array.from({ length: Math.max(1, testimonials.length - 2) }).map((_, index) => (
            <button
              key={index}
              onClick={() => {
                setIsTransitioning(true);
                setTimeout(() => {
                  setCurrentIndex(index);
                  setIsTransitioning(false);
                }, 150);
              }}
              className={`h-2 rounded-full transition-all duration-300 ${
                currentIndex === index ? 'w-8 bg-purple-500' : 'w-2 bg-gray-300'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

